/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import React, { forwardRef } from 'react';
import { UploadIcon } from 'tdesign-icons-react';
import classNames from 'classnames';
import NormalFile from './themes/NormalFile.js';
import DraggerFile from './themes/DraggerFile.js';
import ImageCard from './themes/ImageCard.js';
import ImageFlowList from './themes/MultipleFlowList.js';
import useUpload from './hooks/useUpload.js';
import { Button } from '../button/index.js';
import { uploadDefaultProps } from './defaultProps.js';
import CustomFile from './themes/CustomFile.js';
import parseTNode from '../_util/parseTNode.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../_chunks/dep-e43cf21c.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-7dce2c26.js';
import '../_util/easing.js';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../common/Portal.js';
import 'react-dom';
import '../loading/gradient.js';
import '../hooks/useDomRefCallback.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-92728dc5.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-e0370ebe.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../link/index.js';
import '../link/Link.js';
import '../link/style/css.js';
import '../_common/js/upload/utils.js';
import '../_common/js/log/log.js';
import '../hooks/useGlobalIcon.js';
import '../hooks/useCommonClassName.js';
import './hooks/useDrag.js';
import '../image-viewer/index.js';
import '../image-viewer/ImageViewer.js';
import '../_chunks/dep-10388ab5.js';
import '../tooltip/index.js';
import '../tooltip/Tooltip.js';
import '../popup/index.js';
import '../popup/Popup.js';
import 'react-transition-group';
import 'react-popper';
import '../hooks/useControlled.js';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-c1f93350.js';
import '../_util/noop.js';
import '../_util/useAnimation.js';
import '../hooks/usePrevious.js';
import '../popup/hooks/useTrigger.js';
import 'react-is';
import '../popup/utils/ref.js';
import '../_util/composeRefs.js';
import '../popup/utils/transition.js';
import '../_util/useMutationObserver.js';
import '../_chunks/dep-01ce608f.js';
import '../_chunks/dep-77a54538.js';
import '../_util/useWindowSize.js';
import '../popup/defaultProps.js';
import '../popup/style/css.js';
import '../popup/type.js';
import '../tooltip/defaultProps.js';
import '../tooltip/TooltipLite.js';
import '../_util/useSwitch.js';
import '../_util/usePersistFn.js';
import '../_common/js/utils/getPosition.js';
import '../tooltip/style/css.js';
import '../tooltip/type.js';
import '../locale/LocalReceiver.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../image-viewer/utils.js';
import '../dialog/index.js';
import '../dialog/Dialog.js';
import '../_util/useSetState.js';
import '../dialog/defaultProps.js';
import '../dialog/DialogCard.js';
import '../button/Button.js';
import '../_util/useRipple.js';
import '../_util/setStyle.js';
import '../button/defaultProps.js';
import '../button/style/css.js';
import '../button/type.js';
import '../dialog/hooks/useDialogEsc.js';
import '../dialog/hooks/useLockStyle.js';
import '../_util/useLayoutEffect.js';
import '../_common/js/utils/getScrollbarWidth.js';
import '../dialog/hooks/useDialogPosition.js';
import '../dialog/hooks/useDialogDrag.js';
import '../dialog/utils.js';
import '../_common/js/log/index.js';
import '../dialog/plugin.js';
import '../dialog/style/css.js';
import '../dialog/type.js';
import '../image-viewer/hooks/useMirror.js';
import '../image-viewer/hooks/usePosition.js';
import '../image-viewer/hooks/useIndex.js';
import '../image-viewer/hooks/useRotate.js';
import '../image-viewer/hooks/useScale.js';
import '../image-viewer/hooks/useIconMap.js';
import '../image-viewer/defaultProps.js';
import '../image-viewer/hooks/useImageScale.js';
import '../image-viewer/hooks/useList.js';
import '../image-viewer/hooks/useViewerScale.js';
import '../image-viewer/style/css.js';
import '../_common/js/upload/main.js';
import '../_common/js/upload/xhr.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function TdUpload(props, ref) {
  var theme = props.theme;
  var _useUpload = useUpload(props),
    locale = _useUpload.locale,
    classPrefix = _useUpload.classPrefix,
    triggerUploadText = _useUpload.triggerUploadText,
    toUploadFiles = _useUpload.toUploadFiles,
    displayFiles = _useUpload.displayFiles,
    uploadValue = _useUpload.uploadValue,
    sizeOverLimitMessage = _useUpload.sizeOverLimitMessage,
    uploading = _useUpload.uploading,
    tipsClasses = _useUpload.tipsClasses,
    errorClasses = _useUpload.errorClasses,
    placeholderClass = _useUpload.placeholderClass,
    inputRef = _useUpload.inputRef,
    disabled = _useUpload.disabled,
    onRemove = _useUpload.onRemove,
    uploadFiles = _useUpload.uploadFiles,
    onNormalFileChange = _useUpload.onNormalFileChange,
    onDragFileChange = _useUpload.onDragFileChange,
    triggerUpload = _useUpload.triggerUpload,
    cancelUpload = _useUpload.cancelUpload;
  React.useImperativeHandle(ref, function () {
    return {
      upload: inputRef.current,
      uploading: uploading,
      triggerUpload: triggerUpload,
      uploadFiles: uploadFiles,
      cancelUpload: cancelUpload
    };
  });
  var renderTrigger = function renderTrigger() {
    var getDefaultTrigger = function getDefaultTrigger() {
      if (theme === "file-input") {
        return /* @__PURE__ */React.createElement(Button, _objectSpread({
          disabled: disabled,
          variant: "outline"
        }, props.triggerButtonProps), triggerUploadText);
      }
      return /* @__PURE__ */React.createElement(Button, _objectSpread({
        disabled: disabled,
        variant: "outline",
        icon: /* @__PURE__ */React.createElement(UploadIcon, null)
      }, props.triggerButtonProps), triggerUploadText);
    };
    return parseTNode(props.trigger, {
      dragActive: false,
      files: uploadValue
    }) || props.children || getDefaultTrigger();
  };
  var triggerElement = renderTrigger();
  var commonDisplayFileProps = {
    files: uploadValue,
    toUploadFiles: toUploadFiles,
    displayFiles: displayFiles,
    theme: theme,
    abridgeName: props.abridgeName,
    placeholder: props.placeholder,
    disabled: props.disabled,
    tips: props.tips,
    sizeOverLimitMessage: sizeOverLimitMessage,
    uploading: uploading,
    classPrefix: classPrefix,
    tipsClasses: tipsClasses,
    errorClasses: errorClasses,
    placeholderClass: placeholderClass,
    locale: locale,
    autoUpload: props.autoUpload,
    showUploadProgress: props.showUploadProgress,
    fileListDisplay: props.fileListDisplay,
    onRemove: onRemove
  };
  var dragProps = {
    onDragFileChange: onDragFileChange,
    onDragenter: props.onDragenter,
    onDragleave: props.onDragleave,
    onDrop: props.onDrop
  };
  var getNormalFileNode = function getNormalFileNode() {
    return /* @__PURE__ */React.createElement(NormalFile, _objectSpread(_objectSpread({}, commonDisplayFileProps), {}, {
      multiple: props.multiple
    }), /* @__PURE__ */React.createElement("div", {
      className: "".concat(classPrefix, "-upload__trigger"),
      onClick: triggerUpload
    }, triggerElement));
  };
  var getSingleFileDraggerUploadNode = function getSingleFileDraggerUploadNode() {
    return /* @__PURE__ */React.createElement(DraggerFile, _objectSpread(_objectSpread({}, commonDisplayFileProps), {}, {
      dragEvents: dragProps,
      trigger: props.trigger,
      cancelUpload: cancelUpload,
      triggerUpload: triggerUpload,
      uploadFiles: uploadFiles
    }));
  };
  var getImageCardUploadNode = function getImageCardUploadNode() {
    return /* @__PURE__ */React.createElement(ImageCard, _objectSpread(_objectSpread({}, commonDisplayFileProps), {}, {
      multiple: props.multiple,
      max: props.max,
      showUploadProgress: props.showUploadProgress,
      triggerUpload: triggerUpload,
      uploadFiles: uploadFiles,
      cancelUpload: cancelUpload,
      onPreview: props.onPreview
    }));
  };
  var getFlowListNode = function getFlowListNode() {
    return /* @__PURE__ */React.createElement(ImageFlowList, _objectSpread(_objectSpread({}, commonDisplayFileProps), {}, {
      isBatchUpload: props.isBatchUpload,
      draggable: props.draggable,
      dragEvents: dragProps,
      uploadFiles: uploadFiles,
      cancelUpload: cancelUpload,
      onPreview: props.onPreview
    }), /* @__PURE__ */React.createElement("div", {
      className: "".concat(classPrefix, "-upload__trigger"),
      onClick: triggerUpload
    }, triggerElement));
  };
  var getCustomFile = function getCustomFile() {
    return /* @__PURE__ */React.createElement(CustomFile, _objectSpread(_objectSpread({}, commonDisplayFileProps), {}, {
      draggable: props.draggable,
      dragContent: props.dragContent,
      dragEvents: dragProps,
      triggerUpload: triggerUpload,
      childrenNode: props.children,
      trigger: props.trigger
    }), triggerElement);
  };
  return /* @__PURE__ */React.createElement("div", {
    className: classNames([props.className, "".concat(classPrefix, "-upload")]),
    style: props.style
  }, /* @__PURE__ */React.createElement("input", {
    ref: inputRef,
    type: "file",
    disabled: disabled,
    onChange: onNormalFileChange,
    multiple: props.multiple,
    accept: props.accept,
    hidden: true
  }), ["file", "file-input"].includes(theme) && !props.draggable && getNormalFileNode(), ["file", "image"].includes(theme) && props.draggable && getSingleFileDraggerUploadNode(), theme === "image" && !props.draggable && getImageCardUploadNode(), ["image-flow", "file-flow"].includes(theme) && getFlowListNode(), theme === "custom" && getCustomFile(), props.tips && /* @__PURE__ */React.createElement("small", {
    className: classNames([tipsClasses, _defineProperty({}, "".concat(classPrefix, "-upload__tips-").concat(props.status), props.status)])
  }, props.tips));
}
var Upload = /*#__PURE__*/forwardRef(TdUpload);
Upload.displayName = "Upload";
Upload.defaultProps = uploadDefaultProps;

export { Upload as default };
//# sourceMappingURL=upload.js.map
